module.exports = __webpack_public_path__ + "img/48.9c4e1312.png";